/* eslint semi:0 */
import 'core-js'
import '../../jsCore/application/bootstrap_common'
import '../../components/body/uaBodyClassModifier'
import mountHeaderComponents from '../../components/header/headerComponents'
import localeCookieInitializer from '../../jsCore/organizedByType/initializers/localeCookieInitializer'
import mountScoresTable from '../../components/scores_table/scoresTableContainer'
import initAdblockDetectorProvider from '../../jsCore/providers/ads/adblockDetectorProvider'
import mountFixturesSchedule from '../../components/schedule/scheduleScoresContainer'
import initAnalytics from '../../jsCore/organizedByType/initializers/analyticsInitializer'
import mountFixturesLeagueSelection from '../../components/schedule/leagueSelectionScoresContainer'
import { getVideoAdsTag } from '../../jsCore/organizedByType/vms/ads/videoAdTag'

import initTvChannelSelection from '../../components/tv_channel_selection/'
import initTvSchedule from '../../components/tv_schedule_container/'
import trackAnalyticsClickEvents from '../../components/track_analytics_click_events/trackAnalyticsClickEvents'
import { LinksGroupContainer } from '../../../../../lib/provolution/components/links_group/presentation/views/linksGroup.container'
import { renderReact } from 'hypernova-react'
import { initCommonComponents } from '../common/common'
import initMontiPlayers from '../../components/monti/montiContainer'

initAnalytics()
initAdblockDetectorProvider()
localeCookieInitializer()
mountHeaderComponents()
mountFixturesLeagueSelection()
mountFixturesSchedule()
mountScoresTable()
trackAnalyticsClickEvents()
initTvChannelSelection()
initTvSchedule()
initCommonComponents()
initMontiPlayers()
getVideoAdsTag()
renderReact('LinksGroupContainer', LinksGroupContainer)



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/entry_points/scoresAndPages/scoresAndPages.js